<script setup lang="ts">
// Option C (2026-10-11): the Signal-tab body for every momentum fund page
// driven by a FundSignalPanelConfig (gold, gge) — replaces GoldSignalTab.vue
// and GgeSignalTab.vue. Dashboard passes FUND_PAGES[slug].signalPanel as
// `config`. The panels self-poll, so `ctx` is accepted (uniform signalTab
// contract) and ignored.
import FundSignalPanel from '../signal/FundSignalPanel.vue'
import HoldingsPanel from '../HoldingsPanel.vue'
import type { SignalTabCtx } from '../nav/fundPages'
import type { FundSignalPanelConfig } from '../signal/fundSignalPanel'

defineProps<{ ctx: SignalTabCtx; config: FundSignalPanelConfig }>()
</script>

<template>
  <FundSignalPanel :config="config" />
  <HoldingsPanel />
  <component :is="c" v-for="(c, i) in config.afterHoldings ?? []" :key="i" />
</template>
